module.exports = __webpack_public_path__ + "media/images/icons/dribbble-da8b8f0dbbdebf2871e4adfcb264d5e8.svg";